define('ROOM4.CCAGalleryShowcase.Showcase.Collection', [
    'Backbone',
    'Utils'
], function(
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Collection.extend({
        url: Utils.getAbsoluteUrl(
            getExtensionAssetsPath('Modules/CCAGalleryShowcase/SuiteScript2/CCAGalleryShowcase.Service.ss'),
            true
        ),

        initialize: function initialize(models, options) {
            options = options || {};

            this.itemId = options.itemId;
            this.limit = options.limit || 6;
            this.totalRecordsFound = 0;
        },

        fetchCases: function fetchCases() {
            return this.fetch({
                data: {
                    action: 'casesByItem',
                    itemId: this.itemId,
                    limit: this.limit
                }
            });
        },

        parse: function parse(response) {
            response = response || {};

            this.totalRecordsFound = parseInt(response.totalRecordsFound, 10) || 0;

            return response.records || [];
        }
    });
});
